import { useAtomValue } from 'jotai';

import {
  Image,
  ImagePlaceholder,
  ImageWrapper,
  Name,
  Reward,
  RewardAndButtonWrapper,
} from './reward_item.styles';

import ReturnButton from './return_button';

import useI18nText from '../../../../hooks/useI18nText';

import { vendorCardRewardQuery } from '../../../../store';

import rewardIcon from '../../../../static/reward.svg';

import type { NotRedeemedRewardTransaction } from '@rewardopl/types';
import type { SetStateAction } from 'jotai';

type RewardItemProps = {
  setRedeemableTransactions: (
    nextValueOrSetter: SetStateAction<NotRedeemedRewardTransaction[]>,
  ) => void;
  transaction: NotRedeemedRewardTransaction;
};

export default function RewardItem({ setRedeemableTransactions, transaction }: RewardItemProps) {
  const { reward_id: rewardId } = transaction;

  const reward = useAtomValue(vendorCardRewardQuery(rewardId));

  const { name, name_i18n: nameI18n, picture } = reward;

  const nameString = useI18nText(nameI18n, name);

  return (
    <RewardAndButtonWrapper>
      <Reward>
        <ImageWrapper>
          {picture ? (
            <Image alt={nameString} src={`/api/uploads/${picture}?w=${70 * devicePixelRatio}`} />
          ) : (
            <ImagePlaceholder alt={nameString} src={rewardIcon} />
          )}
        </ImageWrapper>
        <Name>{nameString}</Name>
      </Reward>
      <ReturnButton
        setRedeemableTransactions={setRedeemableTransactions}
        transaction={transaction}
      />
    </RewardAndButtonWrapper>
  );
}
